import { ApiRecordType } from '../entities/api-record-type.entity';

/**
 * Returns a localized display label for an ApiRecordType.
 * - Picks the first label matching `locale`; falls back to `recordType.Name`.
 * - If more than one option yields the same localized label, appends `(${recordType.Name})` to disambiguate.
 */
export function getRecordTypeOptionLabel(recordType: ApiRecordType, locale: string, options: ApiRecordType[]): string {
    const recordLabel: string = recordType.Labels.find(label => label.Lang === locale)?.Value ?? recordType.Name;

    // Determine if this label is duplicated among the provided options (early-exit on second match)
    let matches = 0;
    for (const option of options) {
        const optionLabel = option.Labels.find(label => label.Lang === locale)?.Value ?? option.Name;

        if (optionLabel === recordLabel && ++matches > 1) {
            break;
        }
    }
    const hasDuplicateLabel: boolean = matches > 1;

    return hasDuplicateLabel ? `${recordLabel} (${recordType.Name})` : recordLabel;
}
